import { createRouter, createWebHistory } from '@ionic/vue-router'
import { RouteRecordRaw } from 'vue-router'
import Tabs from '@/views/Tabs.vue'
import { authGuard } from '@/services/auth'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/onboarding'
  },
  {
    path: '/onboarding',
    component: () => import('@/views/Onboarding.vue')
  },
  {
    path: '/login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/reset',
    beforeEnter: (_to, _from, next) => {
      ['receiptai_token','receiptai_refresh_token','receiptai_user','recash_onboarding_done'].forEach(k => localStorage.removeItem(k))
      next('/login')
    },
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/about',
    component: () => import('@/views/About.vue')
  },
  {
    path: '/pricing',
    component: () => import('@/views/Pricing.vue')
  },
  {
    path: '/payment/success',
    component: () => import('@/views/PaymentSuccess.vue')
  },
  {
    path: '/payment/cancel',
    component: () => import('@/views/PaymentCancel.vue')
  },
  {
    path: '/payment/paypal-return',
    component: () => import('@/views/PaypalReturn.vue')
  },
  {
    path: '/referral',
    component: () => import('@/views/Referral.vue')
  },
  {
    path: '/legal',
    component: () => import('@/views/Legal.vue')
  },
  {
    path: '/support',
    component: () => import('@/views/Support.vue')
  },
  {
    path: '/guide',
    component: () => import('@/views/Guide.vue')
  },
  {
    path: '/ticket/:id',
    component: () => import('@/views/TicketDetail.vue')
  },
  {
    path: '/health-dashboard',
    component: () => import('@/views/HealthDashboard.vue')
  },
  {
    path: '/ethical-points',
    component: () => import('@/views/EthicalPointsDashboard.vue')
  },
  {
    path: '/budget',
    component: () => import('@/views/Budget.vue')
  },
  {
    path: '/shopping-list',
    component: () => import('@/views/ShoppingList.vue')
  },
  {
    path: '/tabs/',
    component: Tabs,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: '/tabs/home'
      },
      {
        path: 'home',
        component: () => import('@/views/Home.vue')
      },
      {
        path: 'wallet',
        component: () => import('@/views/Wallet.vue')
      },
      {
        path: 'scan',
        component: () => import('@/views/Scan.vue')
      },
      {
        path: 'alerts',
        component: () => import('@/views/Alerts.vue')
      },
      {
        path: 'tickets',
        component: () => import('@/views/Tickets.vue')
      },
      {
        path: 'profile',
        component: () => import('@/views/Profile.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

router.beforeEach(authGuard)

export default router
